<template>
  <div>
    <div class="text-right mb-4" v-if="panels.length > 10">
      <button class="rounded btn btn--gray font-normal text-sm" @click="toggleAll">
        {{ expandButtonText }}
      </button>
    </div>

    <slot v-on:accordion-panel-toggled="togglePanels" />
    
    <div class="text-right mt-4" v-if="panels.length >= 3">
      <button class="rounded btn btn--gray font-normal text-sm" @click="toggleAll">
        {{ expandButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      panels: [],
      allExpanded: false
    }
  },

  created() {
    this.panels = this.$children;

    this.$on("accordion-panel-toggled", this.togglePanels);
  },

  computed: {
    expandButtonText() {
      return this.allExpanded ? 'Collapse All' : 'Expand All'
    }
  },

  methods: {
    togglePanels(data) {
      // don't need to do anything on a panel closing
      if (data.open) {
        this.panels.forEach(panel => {
          if (panel.htmlId !== data.htmlId) {
            panel.closePanel()
          }
        });
      }
    },
    
    toggleAll() {
      this.panels.forEach(panel => {
        this.allExpanded === true ?
          panel.closePanel()
          : panel.openPanel();
      });

      this.allExpanded = !this.allExpanded
    }
  }
}
</script>
